import { Link } from "react-router-dom";

import { PLATFORM_NAME, filesFor, mb, useDetectedSystem, useDownloads } from "../downloads";
import { useInstallState } from "../install";

/**
 * "Get StrategyHive" on the front page: the desktop download for this visitor's
 * system as one button, and the website installed as an app beside it. On a
 * phone or tablet the app tile comes first, because the desktop app is no use there.
 */
export function GetTheApp() {
  const downloads = useDownloads();
  const d = useDetectedSystem();
  const { state, install } = useInstallState();
  const files = downloads.data?.files ?? [];
  const mine = filesFor(files, d);
  const best = mine.find((f) => f.kind !== "deb") ?? mine[0];
  const phone = d.browser === "ios" || d.browser === "android";
  const platforms = [...new Set(files.map((f) => f.platform))];

  const desktop = (
    <div className="get-app__tile">
      <h3>Desktop app</h3>
      <p className="muted small">
        Backtests and paper bots on your own computer. Offline, no account needed.
        {platforms.length > 0 && ` For ${platforms.map((p) => PLATFORM_NAME[p]).join(", ")}.`}
      </p>
      <div className="row get-app__actions">
        {best ? (
          <a className={`btn${phone ? "" : " btn--primary"}`} href={best.url} download>
            ⬇ Download for {PLATFORM_NAME[best.platform]}
            {best.platform === "mac" && mine.length > 1 ? "" : ` · ${mb(best.size)}`}
          </a>
        ) : (
          <Link className={`btn${phone ? "" : " btn--primary"}`} to="/download">
            ⬇ Download the desktop app
          </Link>
        )}
        <Link className="btn btn--ghost" to="/download">
          All downloads →
        </Link>
      </div>
      {best && downloads.data?.version && (
        <p className="muted small">
          Version {downloads.data.version}
          {best.platform === "linux" && " · AppImage (a .deb is on the Download page)"}
        </p>
      )}
    </div>
  );

  const web = (
    <div className="get-app__tile">
      <h3>{phone ? "On this phone" : "In your browser, as an app"}</h3>
      <p className="muted small">
        Your account, the community and your bots in their own window, with push notifications. Nothing to
        download.
      </p>
      <div className="row get-app__actions">
        {state === "available" ? (
          <button
            type="button"
            className={`btn${phone ? " btn--primary" : ""}`}
            onClick={() => void install()}
          >
            ⤓ Install StrategyHive
          </button>
        ) : state === "installed" ? (
          <span className="badge">Installed</span>
        ) : (
          <Link className={`btn${phone ? " btn--primary" : ""}`} to="/download#web-app">
            {d.browser === "ios" ? "Add to Home Screen: how" : "How to install it"}
          </Link>
        )}
      </div>
    </div>
  );

  return (
    <section className="card get-app" aria-labelledby="get-app-title">
      <div className="card__body">
        <h2 id="get-app-title">Get StrategyHive</h2>
        <div className="get-app__tiles">
          {phone ? (
            <>
              {web}
              {desktop}
            </>
          ) : (
            <>
              {desktop}
              {web}
            </>
          )}
        </div>
      </div>
    </section>
  );
}
